import {
  Combobox,
  type ComboboxOption
} from '@library/components/selects/combobox/Combobox';
import { useMemo } from 'react';

export interface CorrelationsChoiceFilterProps {
  disabled?: boolean;
  id: string;
  onChange: (value: string) => void;
  value: string | undefined;
}

export const CorrelationsChoiceFilter = ({
  disabled = false,
  id,
  onChange,
  value
}: CorrelationsChoiceFilterProps) => {
  const filterOptions: Array<ComboboxOption> = useMemo(
    () => [
      {
        label: 'Less',
        value: 'Less'
      },
      {
        label: 'More',
        value: 'More'
      }
    ],
    []
  );

  const selectedChoiceOption: ComboboxOption | null = useMemo(
    () =>
      value
        ? (filterOptions.find((option) => option.value === value) ?? null)
        : null,
    [filterOptions, value]
  );

  const handleChoiceChange = (selectedValue: ComboboxOption | null) => {
    onChange(selectedValue?.value.toString() || '');
  };

  return (
    <div className="border-soFresh-140 w-28">
      <div className="w-full">
        <Combobox
          disabled={disabled}
          id={id}
          closeMenuOnSelect
          isMulti={false}
          label=""
          value={selectedChoiceOption}
          placeholder="Select Choice..."
          onChange={handleChoiceChange}
          options={filterOptions}
          allowSelectAll={false}
          isClearable={false}
        />
      </div>
    </div>
  );
};
